import React, { Component } from 'react';
import { Table } from 'semantic-ui-react';

class OtherCostTableRow extends Component {
  handleEdit = () => {
    this.props.onEdit(this.props.item);
  }
  render() { 
    const { description, cost } = this.props.item;
    return (
      <Table.Row>
        <Table.Cell>{description}</Table.Cell>
        <Table.Cell>{cost}</Table.Cell>
        <Table.Cell>
          <a href='#edit-cost' onClick={this.handleEdit}>Edit</a>
          &emsp;
          <a href='#remove-cost' onClick={() => this.props.onRemove(this.props.item)}>Remove</a>
        </Table.Cell>
      </Table.Row>
    )
  }
}
 
export default OtherCostTableRow;


// WEBPACK FOOTER //
// ./src/components/jobs/OtherCostTableRow.js